"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragAndDropAreaFactory = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var factory_1 = require("../internal/factory");
var units_1 = require("../internal/units");
var unitToStyle_1 = require("../internal/unitToStyle");
var stateSettings = {
    shadow: units_1.UNITS.SHADOW.asOptional(),
    border: units_1.UNITS.BORDER.asOptional(),
    palette: {
        type: 'Object',
        required: false,
        properties: {
            overlay: units_1.UNITS.COLOR.asOptional(),
            background: units_1.UNITS.COLOR.asOptional(),
            border: units_1.UNITS.COLOR.asOptional()
        }
    }
};
exports.DragAndDropAreaFactory = factory_1.factory({
    name: 'DragAndDropArea',
    settings: {
        padding: units_1.UNITS.PADDING.asOptional(),
        border: units_1.UNITS.BORDER.asOptional(),
        shadow: units_1.UNITS.SHADOW.asOptional(),
        palette: {
            type: 'Object',
            required: false,
            properties: {
                background: units_1.UNITS.COLOR.asOptional(),
                border: units_1.UNITS.COLOR.asOptional()
            }
        }
    },
    $when: {
        dropping: stateSettings
    },
    component: function (_a) {
        var _b, _c, _d, _e;
        var settings = _a.settings, $when = _a.$when;
        var stateToStyle = function (state) {
            var _a, _b;
            return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        ", "\n        ", "\n        ", "\n        ", "\n      "], ["\n        ", "\n        ", "\n        ", "\n        ", "\n      "])), state !== undefined && state.shadow !== undefined ? unitToStyle_1.shadowToStyle(state.shadow) : '', state !== undefined && state.border !== undefined ? unitToStyle_1.borderToStyle(state.border) : '', unitToStyle_1.ifDefined('border-color', (_a = state === null || state === void 0 ? void 0 : state.palette) === null || _a === void 0 ? void 0 : _a.border), unitToStyle_1.ifDefined('background-color', (_b = state === null || state === void 0 ? void 0 : state.palette) === null || _b === void 0 ? void 0 : _b.background));
        };
        var DragAndDropArea = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      /* DragAndDropArea is a growing flex item */\n      flex-grow: 1;\n      flex-shrink: 1;\n      align-self: stretch;\n      flex-basis: 100%;\n\n      position: relative; \n\n      ", "\n      ", "\n      ", "\n\n      ", "\n      ", "\n\n      ", "\n    "], ["\n      /* DragAndDropArea is a growing flex item */\n      flex-grow: 1;\n      flex-shrink: 1;\n      align-self: stretch;\n      flex-basis: 100%;\n\n      position: relative; \n\n      ", "\n      ", "\n      ", "\n\n      ", "\n      ", "\n\n      ", "\n    "])), settings.padding !== undefined ? unitToStyle_1.paddingToStyle(settings.padding) : '', settings.border !== undefined ? unitToStyle_1.borderToStyle(settings.border) : '', settings.shadow !== undefined ? unitToStyle_1.shadowToStyle(settings.shadow) : '', unitToStyle_1.ifDefined('border-color', (_b = settings === null || settings === void 0 ? void 0 : settings.palette) === null || _b === void 0 ? void 0 : _b.border), unitToStyle_1.ifDefined('background-color', (_c = settings === null || settings === void 0 ? void 0 : settings.palette) === null || _c === void 0 ? void 0 : _c.background), function (p) { return (p.highlight === true ? stateToStyle($when.dropping) : ''); });
        var Overlay = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      pointer-events: none;\n\n      width: 100%;\n      height: 100%;\n\n      position: absolute;\n      left: 0;\n      top: 0;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      /* Include border-radius */\n      border: none;\n      background: rgba(255, 255, 255, 0.3);\n\n      ", "\n    "], ["\n      pointer-events: none;\n\n      width: 100%;\n      height: 100%;\n\n      position: absolute;\n      left: 0;\n      top: 0;\n\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      /* Include border-radius */\n      border: none;\n      background: rgba(255, 255, 255, 0.3);\n\n      ", "\n    "])), unitToStyle_1.ifDefined('background-color', (_e = (_d = $when === null || $when === void 0 ? void 0 : $when.dropping) === null || _d === void 0 ? void 0 : _d.palette) === null || _e === void 0 ? void 0 : _e.overlay));
        return function (_a) {
            var onDropMessage = _a.onDropMessage, onChange = _a.onChange, children = _a.children, disabled = _a.disabled, restProps = __rest(_a, ["onDropMessage", "onChange", "children", "disabled"]);
            var _b = react_1.useState(false), highlighted = _b[0], setHighlight = _b[1]; // We use a highligh state, since theres no supported :drop css selector (coming in CSS4)
            var _disabled = disabled === true;
            var preventDefaults = function (e) {
                e.preventDefault();
                e.stopPropagation();
            };
            var highlight = function (e) {
                preventDefaults(e);
                setHighlight(!_disabled && true);
            };
            var unhighlight = function (e) {
                preventDefaults(e);
                setHighlight(false);
            };
            var onDrop = function (e) {
                unhighlight(e);
                var files = e.dataTransfer.files;
                !_disabled && onChange(Array.from(files));
            };
            return (react_1.default.createElement(DragAndDropArea, __assign({}, restProps, { highlight: highlighted, onDragEnter: highlight, onDragOver: highlight, onDragLeave: unhighlight, onDrop: onDrop }),
                children,
                highlighted && !_disabled && react_1.default.createElement(Overlay, null, onDropMessage)));
        };
    }
});
var templateObject_1, templateObject_2, templateObject_3;
